// Navegadores de celular normalmente não disparam "dblclick" (o toque duplo vira zoom ou é ignorado).
// Estes handlers mantêm o duplo clique do mouse e reconhecem o toque duplo no touch.

const DOUBLE_TAP_MS = 300;
const MAX_TAP_MOVE_PX = 10;
// Alguns navegadores ainda disparam dblclick depois do toque duplo: ignora para não executar duas vezes
const IGNORE_DBLCLICK_AFTER_TAP_MS = 700;

/**
 * Devolve { onDoubleClick, onTouchStart, onTouchEnd } para espalhar no elemento:
 *   <div {...doubleTapHandlers(() => abrirDetalhe())} />
 * O estado do toque fica no próprio elemento do DOM, que o React reaproveita entre renderizações.
 */
export default function doubleTapHandlers(callback) {
    if (!callback) {
        return {};
    }

    return {
        onDoubleClick: (event) => {
            const element = event.currentTarget;
            if (element.__doubleTapAt && Date.now() - element.__doubleTapAt < IGNORE_DBLCLICK_AFTER_TAP_MS) {
                return;
            }
            callback(event);
        },
        onTouchStart: (event) => {
            const touch = event.touches[0];
            event.currentTarget.__touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
        },
        onTouchEnd: (event) => {
            const element = event.currentTarget;
            const start = element.__touchStart;
            const touch = event.changedTouches[0];

            // Arrastar (rolar a grid) não conta como toque
            if (start && touch && (Math.abs(touch.clientX - start.x) > MAX_TAP_MOVE_PX || Math.abs(touch.clientY - start.y) > MAX_TAP_MOVE_PX)) {
                element.__lastTapAt = 0;
                return;
            }

            const now = Date.now();
            if (element.__lastTapAt && now - element.__lastTapAt < DOUBLE_TAP_MS) {
                element.__lastTapAt = 0;
                element.__doubleTapAt = now;
                callback(event);
            } else {
                element.__lastTapAt = now;
            }
        }
    };
}
